import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from "./components/Home";
import Types from "./components/Types";
import Kinds from "./components/Kinds";
import Weights from "./components/Weights";
import Sizes from "./components/Sizes";
import Colors from "./components/Colors";
import Stones from "./components/Stones";
import Luxurious from "./components/Luxurious"; 
import Requests from "./components/Requests";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Applicants from "./components/Applicants";
import Settings from "./components/Settings";
import StuffTypes from "./components/StuffTypes";
import Jenses from "./components/Jenses";
import Rings from "./components/Rings";

import Templates from "./components/Managments/Templates";
import Websites from "./components/Managments/Websites";
import Users from "./components/Managments/Users";
import User from "./components/Managments/User";

export default class App extends Component {
    getDefaultGuid() {
        return '00000000-0000-0000-0000-000000000000';
    }
  render() {
    return (
      <Layout>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route path='/login' element={<Login />} />
                <Route path='/profile' element={<Profile />} />

                <Route path='/types' element={<Types />} />
                <Route path='/kinds' element={<Kinds />} />
                <Route path='/weights' element={<Weights />} />
                <Route path='/sizes' element={<Sizes />} />
                <Route path='/colors' element={<Colors />} />
                <Route path='/luxurious/:templateId' element={<Luxurious />} />
                <Route path='/requests' element={<Requests />} />
                <Route path='/stones/:templateId' element={<Stones />} />
                <Route path='/applicants' element={<Applicants />} />
                <Route path='/jenses' element={<Jenses />} />
                <Route path='/stufftypes' element={<StuffTypes />} />
                <Route path='/rings' element={<Rings />} />
                
                <Route path='/user/new' element={<User Id={0} />} />
                <Route path='/user/edit/:id' element={<User Id={1} />} />
                <Route path='/users' element={<Users />} />

                <Route path='/websites' element={<Websites />} />

                <Route path='/templates' element={<Templates />} />
                
                <Route path='/settings' element={<Settings />} />

        </Routes>
      </Layout>
    );
  }
}